import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { login } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CompanyLoginModal = ({ show, onHide, onSwitchToRegister, onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const isEn = i18n.language === 'en';

    const inp = {
        width: '100%', padding: '0.75rem 1rem', borderRadius: 12, border: '1.5px solid #e5e7eb',
        fontSize: '0.95rem', outline: 'none', transition: 'border-color 0.15s',
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);
        try {
            const response = await login(username, password, true);
            if (response.is_company) {
                localStorage.setItem('token', response.token);
                localStorage.setItem('user_type', 'company');
                localStorage.setItem('user_id', response.user_id);
                localStorage.setItem('company_id', response.company_id);
                onHide();
                if (onLoginSuccess) onLoginSuccess();
                navigate('/company-dashboard');
            } else {
                setError(isEn ? 'This account is not registered as a company.' : 'Questo account non è registrato come azienda.');
            }
        } catch (err) {
            setError(err.response?.status === 400
                ? (isEn ? 'Invalid credentials. Check your username and password.' : 'Credenziali non valide. Verifica username e password.')
                : (isEn ? 'Login error. Please try again later.' : 'Errore durante il login. Riprova più tardi.'));
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setUsername(''); setPassword(''); setError(null); onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton style={{ border: 'none', paddingBottom: 0 }}>
                <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.25rem' }}>
                        <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,var(--primary),var(--secondary))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' }}>
                            🏢
                        </div>
                        <span style={{ fontWeight: 800, fontSize: '1.15rem', color: '#0F172A' }}>{isEn ? 'Company Login' : 'Accesso Azienda'}</span>
                    </div>
                    <p style={{ fontSize: '0.82rem', color: '#94a3b8', margin: 0 }}>{isEn ? 'Manage your events and monitor performance' : 'Gestisci i tuoi eventi e monitora le performance'}</p>
                </div>
            </Modal.Header>

            <Modal.Body style={{ padding: '1.25rem 2rem 2rem' }}>
                {error && (
                    <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '0.75rem 1rem', marginBottom: '1rem', color: '#dc2626', fontSize: '0.875rem' }}>
                        ⚠️ {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ fontWeight: 600, fontSize: '0.85rem', color: '#374151', display: 'block', marginBottom: '0.4rem' }}>Username</label>
                        <input
                            type="text" value={username} onChange={e => setUsername(e.target.value)}
                            placeholder={isEn ? 'Your company username' : 'Il tuo username aziendale'} required disabled={isLoading}
                            style={inp}
                            onFocus={e => e.target.style.borderColor = 'var(--primary)'}
                            onBlur={e => e.target.style.borderColor = '#e5e7eb'}
                        />
                    </div>
                    <div style={{ marginBottom: '1.5rem' }}>
                        <label style={{ fontWeight: 600, fontSize: '0.85rem', color: '#374151', display: 'block', marginBottom: '0.4rem' }}>Password</label>
                        <input
                            type="password" value={password} onChange={e => setPassword(e.target.value)}
                            placeholder="••••••••" required disabled={isLoading}
                            style={inp}
                            onFocus={e => e.target.style.borderColor = 'var(--primary)'}
                            onBlur={e => e.target.style.borderColor = '#e5e7eb'}
                        />
                    </div>
                    <button type="submit" disabled={isLoading} style={{
                        width: '100%', padding: '0.75rem', borderRadius: '9999px',
                        background: 'linear-gradient(135deg,var(--primary),var(--secondary))', border: 'none',
                        color: '#fff', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
                        opacity: isLoading ? 0.7 : 1,
                    }}>
                        {isLoading ? <><Spinner animation="border" size="sm" /> {isEn ? 'Logging in…' : 'Accesso in corso…'}</> : (isEn ? '🏢 Log in as Company' : '🏢 Accedi come Azienda')}
                    </button>
                </form>

                <div style={{ textAlign: 'center', marginTop: '1.25rem', fontSize: '0.85rem', color: '#64748B' }}>
                    {isEn ? "Don't have a company account yet?" : 'Non hai ancora un account aziendale?'}{' '}
                    <button type="button" onClick={() => { handleClose(); onSwitchToRegister?.(); }}
                        style={{ background: 'none', border: 'none', color: 'var(--primary)', fontWeight: 700, cursor: 'pointer', padding: 0 }}>
                        {isEn ? 'Register your company' : 'Registra la tua azienda'}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CompanyLoginModal;
